import React from "react";

const Cell = ({ cellData }) => {
  return <td class="px-4 py-3">{cellData}</td>;
};

export default Cell;
